import { useRef } from 'react'
import { useStatsBox } from '../../../lib/ctx/stats_box'
import { useGSAP } from '@gsap/react'
import { css } from '@fable/theme'
import { StreakCalendar } from './chart'
import { gsap } from 'gsap'
import { useStats } from '../../../lib/ctx/stats'

interface Props {
  skipAnim?: boolean
  hideMonthTabs?: boolean
}

export const MomStreaksContent = ({
  skipAnim = false,
  hideMonthTabs = false,
}: Props) => {
  const streakMonth = useStats((s) => s.streakMonth)
  const viewed = useStatsBox((s) => s.viewed)
  const scope = useRef<HTMLDivElement>(null)

  useGSAP(
    () => {
      const tl = gsap.timeline()

      const cells = gsap.utils.toArray('.anim__streak-calendar-cell')
      const books = gsap.utils.toArray('.anim__streak-calendar-books')

      if (skipAnim) {
        tl.set(cells, { opacity: 1 })
        if (books.length) {
          tl.set(books, { y: 0, opacity: 1 })
        }
        return
      }

      if (!viewed) return

      tl.to(cells, {
        opacity: 1,
        duration: 0.5,
        stagger: 0.02,
        ease: 'power2.out',
      })

      if (!books.length) return

      tl.to(
        books,
        {
          opacity: 1,
          y: 0,
          duration: 0.5,
          stagger: 0.02,
          ease: 'power2.out',
        },
        '-=0.5'
      )
    },
    { scope, dependencies: [viewed, streakMonth], revertOnUpdate: true }
  )

  return (
    <div
      ref={scope}
      className={css`
        padding-top: 14px;
        width: 100%;
      `}
    >
      <StreakCalendar hideMonthTabs={hideMonthTabs} />
    </div>
  )
}
